export const generateFollowUpReminderEmail = ({
  patientName,
  followUpDate,
  doctorName,
  followUpPeriod,
}) => {
  return {
    subject: `Your Health Follow-up has been Scheduled`,
    html: `
      <div style="font-family: Arial, sans-serif; line-height: 1.6;">
        <h2>Health Follow-up Scheduled</h2>
        <p>Dear ${patientName},</p>
        <p>This is a confirmation that your next health follow-up has been scheduled by Dr. ${doctorName}.</p>
        <p>
          Based on your recent results, a follow-up blood test has been scheduled for you in <strong>${followUpPeriod}</strong>, around <strong>${followUpDate}</strong>.
        </p>
        <p>
          Our concierge testing service will reach out to you closer to the date to confirm the exact time and location for your at-home blood draw.
        </p>
        <p>
          This proactive monitoring is a key part of your personalized health plan to ensure we are tracking your progress effectively.
        </p>
        <p>If you have any questions, please don't hesitate to contact our office.</p>
        <p>Best regards,</p>
        <p>The Team at ClubMed</p>
      </div>
    `,
  };
};
